// import { useState, useEffect } from "react";
// import { Avatar, Menu, Dropdown, Space, Badge } from "antd";
// import { UserOutlined, LogoutOutlined, BellOutlined } from "@ant-design/icons";
// import { Link } from "react-router-dom";
// import { useAuth } from "./auth"; // Import auth module

// export default function LoggedUser({ onLogout, username }) {
//   const [notifications, setNotifications] = useState([]);
//   const auth = useAuth();

//   useEffect(() => {
//     const fetchNotifications = async () => {
//       try {
//         const response = await fetch(`${process.env.REACT_APP_API_URL}/notificaciones?u=${auth.UID}`);
//         const data = await response.json();
//         setNotifications(data);
//       } catch (error) {
//         console.error("Error fetching notifications:", error);
//       }
//     };

//     fetchNotifications(); // Initial fetch
//     const interval = setInterval(fetchNotifications, 10000); // Fetch every 10 seconds

//     return () => clearInterval(interval);
//   }, []);

//   const notificationsMenu = (
//     <Menu>
//       {notifications.length > 0 ? (
//         notifications.slice(0, 5).map((notification) => (
//           <Menu.Item key={notification.NotificacionID}>
//             <Link to={notification.TargetURL || "/notificaciones"}>{notification.Mensaje}</Link>
//           </Menu.Item>
//         ))
//       ) : (
//         <Menu.Item key="no-notifications" disabled>
//           No hay notificaciones
//         </Menu.Item>
//       )}
//       <Menu.Divider />
//       <Menu.Item key="view-all">
//         <Link to="/notificaciones">Ver todas</Link>
//       </Menu.Item>
//     </Menu>
//   );

//   const userMenu = (
//     <Menu>
//       <Menu.Item key="0">
//         <Link to="/perfil">
//           <Space>
//             <UserOutlined />
//             <span>Perfil de usuario</span>
//           </Space>
//         </Link>
//       </Menu.Item>
//       <Menu.Item key="1">
//         <Link to="/" onClick={onLogout}>
//           <Space>
//             <LogoutOutlined />
//             <span>Cerrar sesión</span>
//           </Space>
//         </Link>
//       </Menu.Item>
//     </Menu>
//   );

//   return (
//     <Space>
//       <Dropdown overlay={notificationsMenu} trigger={["click"]}>
//         <Space className="notification-wrapper">
//           <Badge count={notifications.length} offset={[-16, 0]}>
//             <Avatar shape="circle" icon={<BellOutlined />} className="Notification-badge" />
//           </Badge>
//         </Space>
//       </Dropdown>

//       <Dropdown overlay={userMenu} trigger={["click"]}>
//         <Space className="logged-user">
//           <Avatar size="default" icon={<UserOutlined />} className="Avatar-circle" />
//           <span className="Avatar-text">{username.length > 10 ? username.substring(0, 10) + "..." : username}</span>
//         </Space>
//       </Dropdown>
//     </Space>
//   );
// }
import { useState, useEffect, useRef } from "react";
import { Avatar, Menu, Dropdown, Space, Badge } from "antd";
import { UserOutlined, LogoutOutlined, BellOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { useAuth } from "./auth"; // Import auth module

export default function LoggedUser({ onLogout, username }) {
  const [notifications, setNotifications] = useState([]);
  const auth = useAuth();

  const prevCount = useRef(0);
  const audioRef = useRef(new Audio("/notificacion.mp3"));

  useEffect(() => {
    audioRef.current.preload = "auto";

    const fetchNotifications = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/notificaciones?u=${auth.UID}`);
        const data = await response.json();

        // Play sound if new notifications arrived
        if (data.length > prevCount.current) {
          audioRef.current.play();
        }

        prevCount.current = data.length;
        setNotifications(data);
      } catch (error) {
        console.error("Error fetching notifications:", error);
      }
    };

    fetchNotifications(); // Initial fetch
    const interval = setInterval(fetchNotifications, 10000); // Every 10s

    return () => clearInterval(interval);
  }, [auth.UID]);

  // Notifications menu as a function so it updates with state
  const notificationsMenu = () => (
    <Menu>
      {notifications.length > 0 ? (
        notifications.slice(0, 5).map((notification) => (
          <Menu.Item key={notification.NotificacionID}>
            <Link to={notification.TargetURL || "/notificaciones"}>{notification.Mensaje}</Link>
          </Menu.Item>
        ))
      ) : (
        <Menu.Item key="no-notifications" disabled>
          No hay notificaciones
        </Menu.Item>
      )}
      <Menu.Divider />
      <Menu.Item key="view-all">
        <Link to="/notificaciones">Ver todas</Link>
      </Menu.Item>
    </Menu>
  );

  const userMenu = (
    <Menu>
      {auth.Rol !== "administrador" && (
        <Menu.Item key="0">
          <Link to="/perfil">
            <Space>
              <UserOutlined />
              <span>Perfil de usuario</span>
            </Space>
          </Link>
        </Menu.Item>
      )}
      <Menu.Item key="1">
        <Link to="/" onClick={onLogout}>
          <Space>
            <LogoutOutlined />
            <span>Cerrar sesión</span>
          </Space>
        </Link>
      </Menu.Item>
    </Menu>
  );

  return (
    <Space>
      <Dropdown overlay={notificationsMenu} trigger={["click"]}>
        <Space className="notification-wrapper">
          <Badge count={notifications.length} offset={[-16, 0]}>
            <Avatar shape="circle" icon={<BellOutlined />} className="Notification-badge" />
          </Badge>
        </Space>
      </Dropdown>

      <Dropdown overlay={userMenu} trigger={["click"]}>
        <Space className="logged-user">
          <Avatar size="default" icon={<UserOutlined />} className="Avatar-circle" />
          <span className="Avatar-text">{username.length > 10 ? username.substring(0, 10) + "..." : username}</span>
        </Space>
      </Dropdown>
    </Space>
  );
}
